export const Config = {apiUrl : '/admin/api'} //for global
// export const Config = {apiUrl : 'http://127.0.0.1/PowerWing/api'} //for local
// 